// extracted by mini-css-extract-plugin
export default {"container":"MasterUI_container__ZMPeo","content":"MasterUI_content__Bjai0","settingsBox":"MasterUI_settingsBox__X1mOo","invisible":"MasterUI_invisible__NX4vL"};